module.exports = __webpack_public_path__ + "static/media/costMonitoring.bd04a373.mp3";